import axiosInstance from '../../utils/axiosConfig'; 
 
 

export async function getPartyDetails(partyId) {
  try {
 
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/party/${partyId}`;
    const response = await axiosInstance.get(url); 
    return response.data;
  } catch (error) {
    console.error(`Error fetching party details: ${error.message}`);
  }
}

export async function getPersonDetails(uid) {
  try {
   const url =  `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/person/GetPersonDetails/${uid}`;
    const response = await axiosInstance.get(url); 
    return response.data;
  } catch (error) {
    console.error(`Error fetching party details: ${error.message}`);
  }
}

export async function getPersonsDetails(uids) {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/person/GetPersonsDetails`;
    const response = await axiosInstance.post(url, { uids });
    return response.data;
  } catch (error) {
    console.error(`Error fetching persons details: ${error.message}`);
    return [];
  }
}

export const createCommunicationChannel = (data) => async (dispatch) => {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/communicationChannel/CreateCommunicationChannel`;
    const response = await axiosInstance.post(url, data);
    return response.data;
};

export const updatePerson = (uid, data) => async (dispatch) => {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/person/UpdatePerson/${uid}`;
    const response = await axiosInstance.put(url, data);
    return response.data;
};
export const addCommunicationChannelToPerson = (data) => async (dispatch) => {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/partyCommunicationChannel/AddCommunicationChannelToParty`;
    const response = await axiosInstance.post(url, data);
    return response.data;
}

export async function getOrganizationDetails(organisationUid) {
    try {

        const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/organisation/GetOrganizationDetails/${organisationUid}`;
        const response = await axiosInstance.get(url);
        return response.data;
    } catch (error) {
        console.error(`Error fetching party details: ${error.message}`);
    }
}

export async function CheckPersonExistence(party) {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/person/CheckPersonExistence`;
    const response = await axiosInstance.post(url, {
      name: party.name,
      lastName: party.lastName,
      identityNumber: party.identityNumber,
    });

    if (response.status === 200) {  
       
      return response.data[0];
    } else {return null }
  } catch (error) {
    console.error(`error`);
  }
}



export async function createPerson(person) {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/person/CreatePerson`;
    const response = await axiosInstance.post(url ,person); 
    return response.data;
  } catch (error) {
    console.error(`Error Create Person: ${error.message}`);
  }
}


export async function AddCommunicationChannelToParty(uid ,communicationChannelId) {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/partyCommunicationChannel/AddCommunicationChannelToParty`;
    const response = await axiosInstance.post(url ,
       {"uid": uid,
        "communicationChannelId" : communicationChannelId }); 
    return response.data;
  } catch (error) {
    console.error(`Error Add Communication Channel To Party: ${error.message}`);
  }
}

export async function updateCommunicationChannel (id, updateData) {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/communicationChannel/UpdateCommunicationChannel/${id}`;
    const response = await axiosInstance.put(url , updateData ); 
    return response.data;
  } catch (error) {
    console.error(`Error update Communication Channel of Party: ${error.message}`);
  }
}
// Supprime la personne et ses canaux de communication (cascade côté ms-party).
// Relance l'erreur : les appelants doivent savoir si la suppression a échoué.
export async function deletePerson (uid) {
  const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/person/DeletePerson/${uid}`;
  const response = await axiosInstance.delete(url);
  return response.data;
}
export async function getCommunicationChannel (id) {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/communicationChannel/GetCommunicationChannelDetails/${id}`;
    const response = await axiosInstance.get(url); 
    return response.data;
  } catch (error) {
    console.error(`Error getting Communication Channel of Party: ${error.message}`);
  }
}